import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InquiriesState } from '../reducers/base-inquiry.reducer';

const getInquiriesState = createFeatureSelector<InquiriesState>('inquiries');

export const getInquiries = createSelector(getInquiriesState, (state) => state?.inquiries);

export const getDepartment = createSelector(getInquiriesState, (state) => state?.department);
export const getSimilarInquiriesList = createSelector(getInquiriesState, (state) => state?.similarInquiriesList);
export const getShiftPlanRangeList = createSelector(getInquiriesState, (state) => state?.shiftPlanCalendarRanges);
export const getShiftPlanList = createSelector(getInquiriesState, (state) => state?.shiftPlanCalendarData);
export const getShiftPlanFormData = createSelector(getInquiriesState, (state) => state?.shiftPlanCalendarData.formData);
export const getPSPInquiry = createSelector(getInquiriesState, (state) => state?.pspInquiry);
export const getResponsibleUsers = createSelector(getInquiriesState, (state) => state.responsibleUsers);
export const getPSPCustomerQualificationPrice = createSelector(
  getInquiriesState,
  (state) => state.pspCustomerQualificationPrice
);
export const getCustomerInquiry = createSelector(getInquiriesState, (state) => state?.customerInquiry);
export const getPSPOfferCreateSurcharges = createSelector(getInquiriesState, (state) => state.pspOfferCreateSurcharges);
export const getCustomerSelectedFilters = createSelector(getInquiriesState, (state) => state?.selectedInquiryFilters);
export const getInquiryBranches = createSelector(getInquiriesState, (state) => state?.branches);
export const getInquiryOffersCloseStatus = createSelector(
  getInquiriesState,
  (state) => state?.inquiryOfferCloseHeaderWrapper
);
export const getDownloadDocument = createSelector(getInquiriesState, (state) => state.downloadDocument);
export const getInquiryCandidates = createSelector(getInquiriesState, (state) => state?.inquiryCandidatesList);
export const getPspInquiryOffers = createSelector(getInquiriesState, (state) => state?.pspInquiryOffersList);
export const getCustomerInquiryOffers = createSelector(getInquiriesState, (state) => state?.customerInquiryOffersList);
export const getDefaultDeliveryTimeList = createSelector(getInquiriesState, (state) => state?.defaultDeliveryTimeList);
export const getInquiryProvidersList = createSelector(getInquiriesState, (state) => state?.inquiryProvidersList);
export const getInquiryDocumentInfo = createSelector(getInquiriesState, (state) => state?.inquiryDocumentInfo);
export const getDownloadedInquiryDocumentFile = createSelector(
  getInquiriesState,
  (state) => state?.downloadedInquiryDocumentFile
);
